module.exports = __webpack_public_path__ + "static/gray-noise-medium-25ef00f73e2e6a8f0e43f8ff5c8ba060.png";